import React, { useEffect, useState , useRef} from "react";
import "../../style.css";
import Header from "./layout/Header";
import { fetchCourse, updateProfile, resetPassword } from "../../services/api";
import { courseDetail } from "../../services/api";
import { useNavigate } from "react-router-dom";
import Loader from "../../images/loader.png";
import Dashboard from "./Dashboard";
import Securityquestion from "./Securityquestion";
import Scoreboard from "./Scoreboard";
import Exam from "./Exam";
import Recharge from "./Recharge";
import CourseResultCard from "./CourseResultCard";
import { CourseContext } from "./CourseContext";
import { SecurityChallengeModal } from "./screens";

const Course = (props) => {
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [course, setCourse] = useState();
  const [pages, setPages] = useState([]);
  const [topic, setTopic] = useState();
  const [topicstatus, setTopicStatus] = useState();
  const [mainloader, setMainLoader] = useState(false);
  const [currentSection, setCurrentSection] = useState();
  const [courseStatus,setCourseStatus] = useState();
  const [reload, setReload] = useState(false);
  const [startcourse, setStartCourse] = useState(false);
  const [progress, setProgress] = useState(0);
  const [username, setUserName] = useState(sessionStorage.getItem("user_name"));
  const [email, setEmail] = useState(sessionStorage.getItem("user_email"));
  const [responseMessage, setResponseMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
  // UI state previously in Dashboard to reduce prop drilling
  const [showSuccess, setShowSuccess] = useState(false);
  const [quizalert, setQuizalert] = useState(false);
  const [sidebarlock, setSidebarlock] = useState(true);

  // Security Challenge state (global)
  // Initialize as null - will be set from fetchCourse API response only
  const [totalTimeElapsed, setTotalTimeElapsed] = useState(null);
  const [breakpoint1, setBreakpoint1] = useState(null);
  const [breakpoint2, setBreakpoint2] = useState(null);
  const [showChallengeModal, setShowChallengeModal] = useState(false);
  const [challengeQuestion, setChallengeQuestion] = useState(null);
  const [challengeAnswer, setChallengeAnswer] = useState("");
  const [challengeSubmitting, setChallengeSubmitting] = useState(false);
  const [askedQuestionIds, setAskedQuestionIds] = useState(() => {
    try {
      const stored = sessionStorage.getItem("asked_question_ids");
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  // Password reset states
  const [resetPasswordData, setResetPasswordData] = useState({ 
    password: "", 
    confirmPassword: "" 
  });
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [resetPasswordMessage, setResetPasswordMessage] = useState("");
  const [resetPasswordError, setResetPasswordError] = useState("");


  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("token");
    if (!isAuthenticated) {
      navigate("/login");
    }
    getcourseprogress();
    getcourse();
  }, [navigate]);

  // Persist askedQuestionIds to sessionStorage
  useEffect(() => {
    sessionStorage.setItem("asked_question_ids", JSON.stringify(askedQuestionIds));
  }, [askedQuestionIds]);

  useEffect(() => {
  }, []); 
  

  const getcourseprogress = async () => {
    setMainLoader(true);
    try {
      const token = sessionStorage.getItem("token");
      const user_id = sessionStorage.getItem("user_id");
      const response = await fetchCourse(token, user_id);
      
      // Set topic with pages_count instead of full pages array
      const currentTopic = response.data.currentTopic;
      if (currentTopic) {
        setTopic(currentTopic);
        // Don't set pages here - they'll be fetched separately via fetchPages API
        setCurrentSection(currentTopic.section);
      }
      
      setSections(response.data.courses);
      if(response.data.topicStatus){
        setTopicStatus(response.data.topicStatus.status);
      }
      setCourseStatus(response.data.courseStatus);
      setProgress(response.data.progress);
      sessionStorage.setItem("testResult",response.data.percent);
      sessionStorage.setItem("total",response.data.score);

      // Initialize total time elapsed from backend ONLY - no fallback to sessionStorage or 0
      // Check both nested and direct paths to handle different API response structures
      const backendTotalTimeElapsed = response.data.data?.totalTimeElapsed ?? 
                                      response.data.data?.total_time_elapsed ??
                                      response.data.totalTimeElapsed ??
                                      response.data.total_time_elapsed ??
                                      null;
      
      console.log("[Course] API Response - total_time_elapsed:", backendTotalTimeElapsed, "from response.data.data:", response.data.data?.total_time_elapsed, "from response.data:", response.data.total_time_elapsed);
      if (backendTotalTimeElapsed != null && Number.isFinite(Number(backendTotalTimeElapsed))) {
        const elapsedSeconds = Number(backendTotalTimeElapsed);
        setTotalTimeElapsed(elapsedSeconds);
        sessionStorage.setItem("total_time_elapsed", String(elapsedSeconds));
        console.log("[Course] ✅ totalTimeElapsed set from backend:", elapsedSeconds, "seconds");
      } else {
        console.error("[Course] ❌ totalTimeElapsed not found in API response. Response structure:", response.data);
      }
      // Initialize breakpoints from backend if available (in seconds)
      const bp1 = response.data.data.breakpoint1 ?? 
                  response.data.data.challengeBreakpoint1 ?? 
                  response.data.data.breakpoint_1 ?? 
                  null;
      const bp2 = response.data.data.breakpoint2 ?? 
                  response.data.data.challengeBreakpoint2 ?? 
                  response.data.data.breakpoint_2 ?? 
                  null;
      
      console.log("[Course] API Response - breakpoint1:", bp1, "breakpoint2:", bp2);
      console.log("[Course] Full response.data keys:", Object.keys(response.data));
      
      // Set breakpoint1 from backend ONLY - no fallback to sessionStorage
      if (bp1 != null && Number.isFinite(Number(bp1))) {
        const bp1Num = Number(bp1);
        setBreakpoint1(bp1Num);
        sessionStorage.setItem("breakpoint1_seconds", String(bp1Num));
        console.log("[Course] ✅ breakpoint1 set from backend:", bp1Num, "seconds");
      } else {
        setBreakpoint1(null);
        console.warn("[Course] ⚠️ breakpoint1 not found in API response");
      }
      
      // Set breakpoint2 from backend ONLY - no fallback to sessionStorage
      if (bp2 != null && Number.isFinite(Number(bp2))) {
        const bp2Num = Number(bp2);
        setBreakpoint2(bp2Num);
        sessionStorage.setItem("breakpoint2_seconds", String(bp2Num));
        console.log("[Course] ✅ breakpoint2 set from backend:", bp2Num, "seconds");
      } else {
        setBreakpoint2(null);
        console.warn("[Course] ⚠️ breakpoint2 not found in API response");
      }
      
      if(!response.data.questionStatus)
      {
        navigate("/course/security-question");
      }
      else{
        sessionStorage.setItem('securityCheck','1');
      }
    
    } catch (error) {
      console.error("Failed to fetch course progress", error);
    } finally {
      setMainLoader(false);
    }
  };
  const handleRetake =()=>{
    var myModalEl = document.getElementById('editProfileModal');
		var modal = window.bootstrap.Modal.getInstance(myModalEl)
		modal.hide();
		navigate("/course/retake-checkout");
	  }
  const getcourse = async () => {
    const token = sessionStorage.getItem("token");
    const response = await courseDetail(token);
    setCourse(response.data.title);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleExitExam=()=>{
    var myModalEl = document.getElementById('cancelexamModal');
		var modal = window.bootstrap.Modal.getInstance(myModalEl)
		modal.hide();
    setStartCourse(false);
    navigate("/course/home");
  }
  const handleNameChange = (e) => {
    setUserName(e.target.value);
  };
  const handleupdateprofile = async () => {
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("user_id");
    const formData = new FormData();
    formData.append("user_name", username);
    formData.append("user_email", email);
    formData.append("user_id", userId);
    

    try {

      const response = await updateProfile(token, formData);
      console.log(response);

      // Check if the response is successful
      if (response.data) {
        sessionStorage.setItem('user',JSON.stringify(response.data.user));
        sessionStorage.setItem("user_email",response.data.user.email);
        sessionStorage.setItem("user_name",response.data.user.name);

        var myModalEl = document.getElementById('editProfileModal');
        var modal = window.bootstrap.Modal.getInstance(myModalEl)
        modal.hide();

        navigate('/course/home');
          setResponseMessage('Profile updated successfully!');
          setErrorMessage(''); // Clear any previous errors
      } else {
          setErrorMessage(response.error || 'An error occurred.');
          setResponseMessage('');
      }
    } catch (error) {
      console.log(error.response.data.errors);
        // Handle any network or unexpected errors
        setErrorMessage(error.response.data.errors);
        setResponseMessage('');
    }
    // if(response.data){
    //   sessionStorage.setItem('user',JSON.stringify(response.data.user));
    //   sessionStorage.setItem("user_email",response.data.user.email);
    //   sessionStorage.setItem("user_name",response.data.user.name);
    //   navigate('/course/home');
    // }
    // console.log(response);
    // navigate("/course/home");
  };

  const refreshSections = async () => {
    const token = sessionStorage.getItem("token");
    const user_id = sessionStorage.getItem("user_id");
    try {
      const response = await fetchCourse(token, user_id);
      setSections(response.data.courses);
      setProgress(response.data.progress);
      // Update current topic if it exists
      if (response.data.currentTopic) {
        setTopic(response.data.currentTopic);
        setCurrentSection(response.data.currentTopic.section);
      }
    } catch (error) {
      console.error("Failed to refresh sections", error);
    }
  };

  const handleExit=async()=>{
    // Close the modal FIRST before doing async operations
    var myModalEl = document.getElementById('exampleModal');
    if (myModalEl) {
      var modal = window.bootstrap.Modal.getInstance(myModalEl);
      
      // Function to clean up modal and backdrop
      const cleanupModal = () => {
        // Remove all backdrops
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
        
        // Remove modal-open class and styles from body
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        
        // Ensure modal is hidden
        if (myModalEl) {
          myModalEl.classList.remove('show');
          myModalEl.style.display = 'none';
          myModalEl.setAttribute('aria-hidden', 'true');
          myModalEl.removeAttribute('aria-modal');
        }
      };
      
      // Only hide if modal instance exists, otherwise modal might already be closed
      if (modal) {
        // Listen for the hidden event to ensure cleanup after animation
        const handleHidden = () => {
          cleanupModal();
          myModalEl.removeEventListener('hidden.bs.modal', handleHidden);
        };
        myModalEl.addEventListener('hidden.bs.modal', handleHidden);
        
        // Hide the modal (this triggers the animation)
        modal.hide();
        
        // Also do immediate cleanup in case event doesn't fire
        cleanupModal();
      } else {
        // If modal instance doesn't exist, manually clean up
        cleanupModal();
      }
      
      // Double-check cleanup after a brief delay to catch any edge cases
      setTimeout(() => {
        cleanupModal();
      }, 200);
    }
    
    // Now do the async operation after modal is closed
    await getcourseprogress();
    setStartCourse(false);
  }

  // Password reset handlers
  const handleResetPassword = async (e) => {
    console.log('handleResetPassword called!');
    e?.preventDefault?.();
    setResetPasswordLoading(true);
    setResetPasswordMessage("");
    setResetPasswordError("");

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setResetPasswordError("Please login first to reset your password");
        return;
      }

      if (resetPasswordData.password !== resetPasswordData.confirmPassword) {
        setResetPasswordError("Passwords do not match");
        return;
      }

      if (resetPasswordData.password.length < 8) {
        setResetPasswordError("Password must be at least 8 characters long");
        return;
      }

      const payload = { 
        password: resetPasswordData.password,
        password_confirmation: resetPasswordData.confirmPassword
      };
      
      console.log('Sending password reset payload:', payload);
      console.log('Token:', token);
      
      const response = await resetPassword(token, payload);
      if (response.data.status === "success") {
        setResetPasswordMessage(response.data.message || "Password updated successfully!");
        setResetPasswordData({ password: "", confirmPassword: "" });
      } else {
        setResetPasswordError(response.data.message || "An error occurred");
      }
    } catch (error) {
      console.error('Password reset error:', error);
      console.error('Error response:', error.response);
      
      if (error.response?.data?.message) {
        setResetPasswordError(error.response.data.message);
      } else if (error.response?.data?.errors) {
        // Handle Laravel validation errors
        const firstError = Object.values(error.response.data.errors)[0][0];
        setResetPasswordError(firstError);
      } else {
        setResetPasswordError(
          "An error occurred while updating your password. Please try again later."
        );
      }
    } finally {
      setResetPasswordLoading(false);
    }
  };

  const handleResetPasswordInputChange = (e) => {
    const { name, value } = e.target;
    setResetPasswordData((prev) => ({ ...prev, [name]: value }));
    if (resetPasswordMessage || resetPasswordError) {
      setResetPasswordMessage("");
      setResetPasswordError("");
    }
  };

  return (
    <>
      {!topic || mainloader ? (
        <div className="loader position-fixed top-0 bottom-0 start-0 end-0 bg-dark">
          <span className="position-absolute top-50 start-50 translate-middle">
            <img src={Loader} alt="Loader" />
          </span>
        </div>
      ) :(
        <>
          <Header />
          <CourseContext.Provider value={{
            // course/meta
            topicstatus,
            course,
            sections,
            pages,
            topic,
            currentSection,
            courseStatus,
            progress,
            startcourse,
            // setters
            setSections,
            setPages,
            setTopic,
            setCurrentSection,
            setStartCourse,
            refreshSections,
            // ui state (moved from Dashboard)
            showSuccess,
            setShowSuccess,
            quizalert,
            setQuizalert,
            sidebarlock,
            setSidebarlock,
            // Security Challenge state
            totalTimeElapsed,
            setTotalTimeElapsed,
            breakpoint1: breakpoint1 ?? null,  // Ensure it's never undefined
            setBreakpoint1,
            breakpoint2: breakpoint2 ?? null,  // Ensure it's never undefined
            setBreakpoint2,
            showChallengeModal,
            setShowChallengeModal,
            challengeQuestion,
            setChallengeQuestion,
            challengeAnswer,
            setChallengeAnswer,
            challengeSubmitting,
            setChallengeSubmitting,
            askedQuestionIds,
            setAskedQuestionIds,
          }}>
          <main className="main">
            <div className="container position-relative z-1 pt-md-5"> 
              {props.component == "dashboardhome" && (
                <Dashboard />
              )}
               {props.component === "securityquestion" &&
                (
                  <Securityquestion/>
                )
                }
                 {props.component === "scoreboard" &&
                (
                  <Scoreboard/>
                )
                }
                 {props.component === "courseresultcard" &&
                (
                  <CourseResultCard startcourse = {startcourse}
                  setStartCourse = {setStartCourse} />
                )
                }
                {props.component === "exam" &&
                (
                  <Exam/>
                )
                }
                {props.component === "retake-checkout" &&
                (
                  <Recharge/>
                )
                }
            </div>
          </main>
          <SecurityChallengeModal />
          </CourseContext.Provider>
          <div
            className="modal fade"
            id="editProfileModal"
            tabIndex="-1"
            aria-labelledby="editProfileModalLabel"
            aria-hidden="true"
            ref={modalRef}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="editProfileModalLabel">
                    Edit Profile
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setErrorMessage('')}
                    ></button>
                </div>
                <div className="modal-body p-4">
                  <form>
                    <h4 className="h4 mb-0">Contact Details</h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-floating mt-4">
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            placeholder={sessionStorage.getItem("user_name")}
                            onChange={handleNameChange}
                            value={username}
                          />
                          <label htmlFor="name">User Name</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating mt-4">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder={sessionStorage.getItem("user_email")}
                            onChange={handleEmailChange}
                            value={email}
                          />
                          <label htmlFor="email">Email Address</label>
                        </div>
                          <label className="text-danger">{errorMessage? errorMessage : ''}</label>
                      </div>
                      {/* {JSON.parse(sessionStorage.getItem('user')).retake_permission === '0'?
                          <div className="col-md-6 mt-4">
                          <label htmlFor="email">You have used your free retake</label>
                          <button
                          type="button"
                          className="btn btn-primary-s mt-3"
                          onClick={handleRetake}
                          >
                          <i className="fa fa-save me-1"></i>
                            Recharge Retake
                          </button>
                          </div>:<></>
                      } */}
                     
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary-s"
                    onClick={handleupdateprofile}
                  >
                    <i className="fa fa-save me-1"></i> Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="changePasswordModal"
            tabIndex="-1"
            aria-labelledby="changePasswordModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="changePasswordModalLabel">
                    Change Password
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body p-4">
                  <form>
                    <h4 className="h4 pb-2">Change Your Password</h4>
                    <p className="line-h-150">
                      Enter your new password below. Make sure it's secure and easy to remember.
                    </p>

                    {resetPasswordMessage && (
                      <div className="alert alert-success" role="alert">
                        <i className="fa fa-check-circle me-2"></i>
                        {resetPasswordMessage}
                      </div>
                    )}

                    {resetPasswordError && (
                      <div className="alert alert-danger" role="alert">
                        <i className="fa fa-exclamation-circle me-2"></i>
                        {resetPasswordError}
                      </div>
                    )}

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-floating mt-4">
                          <input
                            type="password"
                            className={`form-control ${resetPasswordData.password && resetPasswordData.password.length < 8 ? 'is-invalid' : ''}`}
                            id="newPassword"
                            name="password"
                            placeholder=" "
                            value={resetPasswordData.password}
                            onChange={handleResetPasswordInputChange}
                            required
                            disabled={resetPasswordLoading}
                            minLength="8"
                          />
                          <label htmlFor="newPassword">New Password</label>
                          {resetPasswordData.password && resetPasswordData.password.length < 8 && (
                            <div className="invalid-feedback text-danger">
                              Password must be at least 8 characters long
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-floating mt-4">
                          <input
                            type="password"
                            className={`form-control ${resetPasswordData.confirmPassword && resetPasswordData.password !== resetPasswordData.confirmPassword ? 'is-invalid' : ''}`}
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder=" "
                            value={resetPasswordData.confirmPassword}
                            onChange={handleResetPasswordInputChange}
                            required
                            disabled={resetPasswordLoading}
                            minLength="8"
                          />
                          <label htmlFor="confirmPassword">Confirm New Password</label>
                          {resetPasswordData.confirmPassword && resetPasswordData.password !== resetPasswordData.confirmPassword && (
                            <div className="invalid-feedback text-danger">
                              Passwords do not match
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-primary-s"
                    onClick={handleResetPassword}
                    disabled={resetPasswordLoading || !resetPasswordData.password.trim() || !resetPasswordData.confirmPassword.trim() || resetPasswordData.password !== resetPasswordData.confirmPassword}
                  >
                    {resetPasswordLoading ? (
                      <>
                        <i className="fa fa-spinner fa-spin me-1"></i> Updating...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-lock me-1"></i> Update Password
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="exampleModal" ref={modalRef} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  You will need to resume from the beginning of this Chapter if you Exit                
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" onClick={handleExit} className="btn btn-primary">Exit</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="cancelexamModal" ref={modalRef} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    If you choose to leave this exam you will be required to start the exam from the beginning.  Any questions you have completed will not be counted. <br></br>
                    <br/> Are you sure you want to Exit?             
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Continue Exam</button>
                  <button type="button" onClick={handleExitExam} className="btn btn-primary">Exit</button>
                </div>
              </div>
            </div>
          </div>
        </>
      )
      }
    </>
  );
};
export default Course;

